import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowLeftCurvedIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 15.6 12.2",
	style: { enableBackground: "new 0 0 15.6 12.2" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n	.arrow-left-angled-st0{fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n"
	}), /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
		className: "arrow-left-angled-st0",
		d: "M4.4,7.8L1,4.4L4.4,1"
	}), /* @__PURE__ */ _jsx("path", {
		className: "arrow-left-angled-st0",
		d: "M14.6,11.2c0-1.8-0.7-3.5-2-4.8s-3-2-4.8-2H1"
	})] }) }) })]
});
export default SvgArrowLeftCurvedIcon;
